<template>
  <div class="popup-messenger" :class="{ opened: openMenu, 'popup-messenger__homepage': squareIconChat}">
    <div class="messenger-button messenger-button_ico i-webim js-webim"
         :class="{ 'loader-webim': showLoader }"
         @click="startChatWebim"
         @mouseover="hideQrCodes"
    >
      <div class="messenger-tooltip">
        <div class="main-content">
          <span>Начать чат</span>
        </div>
      </div>
    </div>
    <div class="messenger-button messenger-button_ico i-tg js-tg"
         :class="{ 'show-qr': qrCode['tg'] }"
         @click="startChatTg('tg')"
         @mouseover="hideQrCodes"
    >
      <div class="messenger-tooltip">
        <div class="main-content">
          <span>Написать в Telegram</span>
        </div>
        <div class="thinks-too-long">
          <div class="thinks-too-long-text">
            Если на вашем компьютере не установлена программа <b>Telegram</b>,
            вы можете открыть ее на другом устройстве, для этого отсканируйте QR-код:
          </div>
          <i class="messenger-qr messenger-qr_tg"></i>
        </div>
      </div>
    </div>
    <div class="messenger-button messenger-button_ico i-viber js-viber"
         :class="{ 'show-qr': qrCode['viber'] }"
         @click="startChatViber('viber')"
         @mouseover="hideQrCodes"
    >
      <div class="messenger-tooltip">
        <div class="main-content">
          <span>Написать в Viber</span>
        </div>
        <div class="thinks-too-long">
          <div class="thinks-too-long-text">
            Если на вашем компьютере не установлена программа <b>Viber</b>,
            вы можете открыть ее на другом устройстве, для этого отсканируйте QR-код:
          </div>
          <i class="messenger-qr messenger-qr_viber"></i>
        </div>
      </div>
    </div>

    <div class="messenger-button messenger-button i-general js-messengers" @click="openMessengerMenu"></div>
  </div>
</template>
<script>

/* global webim, ym */

const WEBIM_LOAD_ERROR = -1;
const WEBIM_LOAD_NONE = 0;
const WEBIM_LOAD_LOADING = 1;
const WEBIM_LOAD_LOADED = 2;

export default {
  name: 'WebimWidget',
  data() {
    return {
      openMenu: false,
      webimLoadStatus: WEBIM_LOAD_NONE,
      showLoader: false,
      qrCode: {
        tg: false,
        viber: false,
      },
      squareIconChat: false,
    };
  },
  watch: {
    webimLoadStatus() {
      if (this.webimLoadStatus >= WEBIM_LOAD_LOADED && this.showLoader === true) {
        webim.handlers.onInit = () => {
          this.showLoader = false;
          this.openMenu = false;
          webim.api.chat.start();
        };
      }
      if (this.webimLoadStatus === WEBIM_LOAD_ERROR) {
        this.showLoader = false;
      }
    },
  },
  computed: {
    isLoaded() {
      return this.webimLoadStatus >= WEBIM_LOAD_LOADED;
    },
  },
  mounted() {
    if (typeof window !== 'undefined' && window.location.pathname === '/') {
      this.squareIconChat = true;
    }
    document.addEventListener('open-webim-chat', () => {
      this.openMenu = true;

      if (this.webimLoadStatus === WEBIM_LOAD_NONE) {
        this.loadWebim();
      }
    });
  },
  methods: {
    openMessengerMenu() {
      this.openMenu = !this.openMenu;
      // Метод с загрузкой webim по кнопке открытия меню чатов перестал работать,
      // поэтому приняли решение сделать загрузку по клику на кнопку открытия чата webim
      // if (this.webimLoadStatus === WEBIM_LOAD_NONE) {
      //   this.loadWebim();
      // }

      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'all_Feedback');
      }
    },
    loadWebim() {
      const webimScript = document.createElement('script');

      //        var oldWebimEnabled = localStorage['WEBIM_ENABLED'];

      // По умолчанию WebIM всегда открывается сразу после загрузки страницы, если был начат диалог (даже, если пользователь ничего не ввел)
      // это приводит к тому, что WebIM будет всплывать по клику на нижнюю кнопку (которая открывает меню чата), а
      // не на правильную кнопку (в меню чата). Чтобы этого избежать, применим грязный костыль:

      // @FIXME: Работает только с localStorage, а у WebIM бывают еще куки
      // if (typeof window.localStorage !== 'undefined') {
      //   try {
      //     localStorage.setItem('WEBIM_CHAT_MINIMIZED', JSON.stringify({ value: true, expires: null }));
      //     localStorage.removeItem('WEBIM_ENABLED');
      //   } catch (e) {
      //     // @TODO: Попробовать установить cookies
      //   }
      // }

      if (typeof window !== 'undefined' && typeof window.webim === 'undefined') {
        window.webim = {
          accountName: 'boxberryru',
          domain: 'boxberryru.webim2.ru',
          location: 'boxberryru',
          //            mode: "off",
        };
      }

      webimScript.type = 'text/javascript';
      webimScript.src = 'https://boxberryru.webim2.ru/js/button.js';
      webimScript.async = true;
      webimScript.defer = true;

      webimScript.onload = () => {
        this.webimLoadStatus = WEBIM_LOAD_LOADED;
      };

      webimScript.onerror = () => {
        this.webimLoadStatus = WEBIM_LOAD_ERROR;
      };

      document.body.appendChild(webimScript);
      this.webimLoadStatus = WEBIM_LOAD_LOADING;
    },
    startChatWebim() {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'all_Feedback_chat');
      }

      if (this.isLoaded === true) {
        this.openMenu = false;
        webim.api.chat.start();
      } else if (this.webimLoadStatus === WEBIM_LOAD_NONE) {
        this.showLoader = true;
        this.loadWebim();
      }
    },
    startChatTg(messengerName) {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'all_Feedback_Telegram');
      }

      this.showQrCode(messengerName);

      window.open('tg://resolve?domain=Boxberrybot');
    },
    startChatViber(messengerName) {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'all_Feedback_Viber');
      }

      this.showQrCode(messengerName);

      window.open('viber://pa/?chatURI=BoxberryBot');
    },
    hideQrCodes() {
      for (const item in this.qrCode) {
        this.qrCode[item] = false;
      }
    },
    showQrCode(messenger) {
      this.hideQrCodes();

      if (window.innerWidth > 720) {
        this.qrCode[messenger] = true;
      }
    },
  },
};
</script>
<style lang="scss">
// Данный стиль убирает масштабирование viewport для открытого чата вебим при фокусе на поле ввода сообщения
.webim-root .webim-dialogue-message {
  textarea, .webim-textarea-ext {
    @media (max-width: 580px) {
      font-size: 16px!important;
    }
  }
}
</style>
